import Map from '../components/modules/map/index';
import HereMap from '../components/modules/map/HereMap';
const map = [
  {
    path: '/map',
    name: 'Map',
    component: Map,
    meta: {
      title: 'Map',
    },
  },
  {
    path: '/hereMap',
    name: 'HereMap',
    component: HereMap,
    meta: {
      title: 'Map',
    },
  },
];

export default map;
